<template>
  <div>
    <tabs-horizontal @input="changedTab" classes="">
      <b-tab-item label="Existing Lead" value="0">
        <div class="search_container">
          <form-field-input
            label="Search for Lead"
            v-model="searchForm.search_term"
            :debounce="searchForLead"
          ></form-field-input>

          <h3 class="search_container--heading">Leads:</h3>

          <form-field-radio
            v-show="recordResults.length"
            label=""
            v-model="form.record_id"
            :items="recordResults"
            :option-label="(preview) => preview.address"
            :option-value="(preview) => preview.record_id"
          ></form-field-radio>

          <p v-if="!recordResults.length" class="search_container--empty">No leads found...</p>
        </div>
      </b-tab-item>

      <b-tab-item label="New Lead" value="1">
        <div class="pt-100">
          <record-form
            ref="recordForm"
            :propContact="this.$store.state.activeContact.contact"
          ></record-form>
        </div>
      </b-tab-item>
    </tabs-horizontal>

    <hr>

    <h3 class="mb-50 has-text-weight-semi-bold">Contact Role</h3>

    <div class="flex flex-vertical-end">
      <form-field-select
        class="mb-0 mr-100"
        style="width: 40%"
        v-model="form.role"
        :validation-errors="validationErrors.role"
      >
        <option v-for="option in ENUMS.RecordRoleEnum" :value="option.value">{{ option.label }}</option>
      </form-field-select>

      <form-field-switch
        label="Make this contact the primary contact?"
        v-model="form.is_primary"
        :validation-errors="validationErrors.is_primary"
        style="margin-bottom: 4px"
      ></form-field-switch>
    </div>

    <hr>

    <h3 class="mb-50 has-text-weight-semi-bold">Make Primary Lead?</h3>

    <form-field-switch
      label="Yes, make this the primary lead for this contact?"
      v-model="form.is_primary_record"
      :validation-errors="validationErrors.is_primary_record"
      style="margin-bottom: 5px"
    ></form-field-switch>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import TabsTab from "../components/tab/TabsTab";
import RecordForm from "./RecordForm";

export default {
  name: "AddRecordToContactForm",
  components: {
    TabsTab,
    RecordForm
  },
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      recordResults: [],
      isExistingRecord: true,
      searchForm: {
        search_term: "",
      },
      defaultForm: {
        id: this.$store.state.activeContact.contact.id,
        role: 0,
        is_primary: false,
        is_primary_record: false,
        record_id: null
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    searchForLead() {
      return this.$api.records.search(this.searchForm)
        .then(res => {
          this.recordResults = res.data;
        });
    },
    changedTab($event) {
      this.isExistingRecord = ($event === "0");
      this.$emit("changeIsExistingRecord", this.isExistingRecord);
    },
    update() {
      // Since the id is set, it will always resolve to the update method
      if (this.isExistingRecord) {
        this.form.record = null;
      } else {
        delete this.$refs.recordForm.form.contact;
        this.form.record = this.$refs.recordForm.form;
        this.form.record_id = null;
      }

      return this.$api.contacts.attachRecord(this.form)
        .then(res => {
          this.$emit("saved");
          this.$buefy.toast.open({
            message: "Lead was attached to Contact",
            type: "is-success"
          });

          this.$store.commit("events/toggleEvent", "reloadContactTable");
          return res;
        })
        .catch(error => {
          this.$emit("errored", error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.search_container {
  padding-top: 1rem;
  min-height: 240px;

  &--heading {
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 0.9rem;
    color: $text-muted;
  }

  &--empty {
    margin-top: 8px;
    font-style: italic;
    color: $text-muted;
  }
}
</style>
